function parseEllipsis(ellipsis) {
  return ellipsis === true ? "1" : `${ellipsis.lineClamp}`;
}

export { parseEllipsis };
//# sourceMappingURL=parseEllipsis.mjs.map
